import { combineReducers } from "redux";
import drawer from "./drawer";

import { firebaseStateReducer } from "react-redux-firebase";
const rootReducer = combineReducers({
  firebase: firebaseStateReducer,
  drawer: drawer
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js